module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/napoli.0a499ff32ad3d25a6b248341a11884b1.jpg";